import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
} from "@chakra-ui/react";
import { useGetUserProfileQuery } from "queries";
import { useUpdateZipCodeQuery } from "queries/Jobs";
import React, { FC } from "react";
import { useRecoilState } from "recoil";
import { jobPayloadState, setUpdatingZip } from "_state/atoms/AppAtoms";

interface IZipAlert {
  isOpen: boolean;
  onClose: () => void;
  confirmHandler?: () => void;
  zipRef: any;
}

const ZipAlert: FC<IZipAlert> = ({ isOpen, onClose, zipRef }) => {
  const cancelRef = React.useRef<any | null>();

  const [isLoading, setLoading] = useRecoilState(setUpdatingZip);

  const { mutate: updateZipCode, isLoading: isUpdatingZip } =
    useUpdateZipCodeQuery();
  const { data: userDetails } = useGetUserProfileQuery();
  const [payload, setPayload] = useRecoilState(jobPayloadState);

  const confirmHandler = (): void => {
    const zipValue = zipRef?.current?.value;
    updateZipCode(
      { zipcode: zipValue },
      {
        onSuccess: () => {
          onClose();
          // setLoading(true);
          setLoading(false);
          setPayload({ ...payload, zipcode: zipValue });
        },
      }
    );
  };

  // useEffect(() => {
  // let t: any = null;
  // if (isLoading) {
  //   t = setTimeout(() => {
  //     setLoading(false);
  //     setPayload({ ...payload, zipcode: zipRef?.current?.value });
  //   }, 1000 * 60);
  // }
  // setLoading(false);
  // setPayload({ ...payload, zipcode: zipRef?.current?.value });
  // return () => clearInterval(t);
  // }, [isLoading]);
  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => undefined}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Save Changes?</AlertDialogHeader>

          <AlertDialogBody>
            Do you want to change your location to{" "}
            <span className="font-semibold"> {zipRef?.current?.value}?</span>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Flex gap={3}>
              <Button
                colorScheme="teal"
                ml={3}
                onClick={confirmHandler}
                isLoading={isUpdatingZip}
                px={6}
              >
                Yes
              </Button>
              <Button
                ref={cancelRef}
                onClick={() => {
                  zipRef.current.value = userDetails?.zipcode;
                  onClose();
                }}
                px={6}
              >
                No
              </Button>
            </Flex>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ZipAlert;
